(function () {
  'use strict';

  const TRANSLATIONS = {
    it: {
      vat_warning: 'Transazioni UE: inserisci un numero di partita IVA UE valido, altrimenti verrà applicato successivamente un adeguamento IVA del 22%.',
      only_cf_invalid: 'Con questa opzione il Codice Fiscale deve contenere esattamente 11 cifre numeriche.',
      kicker: 'Fatturazione', title: 'Completa i dati fiscali', subtitle: 'Inserisci le informazioni necessarie prima di procedere al checkout.', close: 'Chiudi', business: 'Azienda', business_hint: 'Impresa o professionista', private: 'Privato', private_hint: 'Persona fisica', country: 'Nazione', country_it: 'Italia', country_de: 'Germania', country_fr: 'Francia', country_at: 'Austria', only_cf: "Possiedo solo il codice fiscale dell'azienda", company_cf: 'Codice Fiscale Azienda *', private_cf: 'Codice Fiscale *', vat: 'Partita IVA *', company_name: 'Ragione Sociale *', sdi: 'Codice SDI *', pec: 'PEC *', cf_placeholder: 'Es: RSSMRA80A01H501U', company_placeholder: 'Es: Acme S.r.l.', sdi_placeholder: 'Es: A1B2C3D (7 caratteri)', pec_placeholder: 'Es: azienda@pec.it', cancel: 'Annulla', confirm: 'Conferma e procedi', saving: 'Salvataggio...', retry: 'Non è stato possibile salvare i dati. Riprova.', edit: 'Modifica', delete: 'Elimina dati di fatturazione', business_invoice: 'Fattura Azienda', private_invoice: 'Fattura Privato', invalid_cf: 'Il Codice Fiscale deve contenere 11 cifre oppure 16 caratteri alfanumerici.', invalid_vat: 'La Partita IVA deve essere di 11 cifre numeriche.', sdi_or_pec: 'Inserisci almeno uno tra Codice SDI e PEC. Puoi anche inserirli entrambi.', offline: 'Connessione assente: impossibile contattare il servizio dei metafield.', metafield_unavailable: 'Il servizio dei metafield non è disponibile (HTTP {status}).', metafield_timeout: 'Il servizio dei metafield non ha risposto entro 5 secondi.', popup_missing: 'Popup fiscale non trovato nella pagina.', customer_id_missing: 'Cliente autenticato rilevato, ma customer.id non è disponibile nel Liquid.', metafield_save_error: 'Salvataggio dei metafield cliente non riuscito.', cart_update_error: 'Aggiornamento carrello non riuscito: {status}', cart_not_confirmed: 'Shopify non ha confermato il salvataggio dei dati fiscali.', vat_generic: 'Partita IVA',
      validation_required: 'Compila questo campo.',
      validation_format: 'Rispetta il formato richiesto.',
      validation_email: 'Inserisci un indirizzo email valido.',
    },
    en: {
      vat_warning: 'EU transactions: enter a valid EU VAT number, otherwise a later 22% VAT adjustment applies.',
      only_cf_invalid: 'With this option, the tax code must contain exactly 11 numeric digits.',
      kicker: 'Billing', title: 'Complete your billing details', subtitle: 'Enter the required information before proceeding to checkout.', close: 'Close', business: 'Business', business_hint: 'Company or professional', private: 'Individual', private_hint: 'Private customer', country: 'Country', country_it: 'Italy', country_de: 'Germany', country_fr: 'France', country_at: 'Austria', only_cf: 'I only have the company tax code', company_cf: 'Company tax code *', private_cf: 'Tax code *', vat: 'VAT number *', company_name: 'Company name *', sdi: 'SDI code *', pec: 'Certified email (PEC) *', cf_placeholder: 'E.g. RSSMRA80A01H501U', company_placeholder: 'E.g. Acme Ltd.', sdi_placeholder: 'E.g. A1B2C3D (7 characters)', pec_placeholder: 'E.g. company@pec.it', cancel: 'Cancel', confirm: 'Confirm and continue', saving: 'Saving...', retry: 'Unable to save the details. Please try again.', edit: 'Edit', delete: 'Delete billing details', business_invoice: 'Business invoice', private_invoice: 'Individual invoice', invalid_cf: 'The tax code must contain 11 digits or 16 alphanumeric characters.', invalid_vat: 'The VAT number must contain 11 digits.', sdi_or_pec: 'Enter at least one of SDI code or PEC. You may also enter both.', offline: 'No connection: unable to contact the customer details service.', metafield_unavailable: 'The customer details service is unavailable (HTTP {status}).', metafield_timeout: 'The customer details service did not respond within 5 seconds.', popup_missing: 'The billing details popup was not found on this page.', customer_id_missing: 'A logged-in customer was detected, but customer.id is unavailable in Liquid.', metafield_save_error: 'Unable to save the customer details.', cart_update_error: 'Unable to update the cart: {status}', cart_not_confirmed: 'Shopify did not confirm that the billing details were saved.', vat_generic: 'VAT number',
      validation_required: 'Please fill out this field.',
      validation_format: 'Please match the requested format.',
      validation_email: 'Please enter a valid email address.',
    },
    de: {
      vat_warning: 'EU-Transaktionen: Geben Sie eine gültige EU-USt-IdNr. ein, andernfalls wird später eine MwSt.-Anpassung von 22 % vorgenommen.',
      only_cf_invalid: 'Bei dieser Option muss die Steuernummer aus genau 11 Ziffern bestehen.',
      kicker: 'Rechnungsstellung', title: 'Rechnungsdaten vervollständigen', subtitle: 'Geben Sie die erforderlichen Angaben ein, bevor Sie zur Kasse gehen.', close: 'Schließen', business: 'Unternehmen', business_hint: 'Firma oder Selbstständiger', private: 'Privatperson', private_hint: 'Privatkunde', country: 'Land', country_it: 'Italien', country_de: 'Deutschland', country_fr: 'Frankreich', country_at: 'Österreich', only_cf: 'Ich besitze nur die Steuernummer des Unternehmens', company_cf: 'Steuernummer des Unternehmens *', private_cf: 'Steuernummer *', vat: 'USt-IdNr. *', company_name: 'Firmenname *', sdi: 'SDI-Code *', pec: 'Zertifizierte E-Mail (PEC) *', cf_placeholder: 'z. B. RSSMRA80A01H501U', company_placeholder: 'z. B. Acme GmbH', sdi_placeholder: 'z. B. A1B2C3D (7 Zeichen)', pec_placeholder: 'z. B. firma@pec.it', cancel: 'Abbrechen', confirm: 'Bestätigen und fortfahren', saving: 'Wird gespeichert...', retry: 'Die Daten konnten nicht gespeichert werden. Bitte versuchen Sie es erneut.', edit: 'Bearbeiten', delete: 'Rechnungsdaten löschen', business_invoice: 'Firmenrechnung', private_invoice: 'Privatrechnung', invalid_cf: 'Die Steuernummer muss aus 11 Ziffern oder 16 alphanumerischen Zeichen bestehen.', invalid_vat: 'Die italienische Umsatzsteuer-ID muss aus 11 Ziffern bestehen.', sdi_or_pec: 'Geben Sie mindestens einen SDI-Code oder eine PEC-Adresse ein. Sie können auch beides angeben.', offline: 'Keine Verbindung: Der Dienst für Kundendaten ist nicht erreichbar.', metafield_unavailable: 'Der Dienst für Kundendaten ist nicht verfügbar (HTTP {status}).', metafield_timeout: 'Der Dienst für Kundendaten hat nicht innerhalb von 5 Sekunden geantwortet.', popup_missing: 'Das Fenster für Rechnungsdaten wurde auf dieser Seite nicht gefunden.', customer_id_missing: 'Ein angemeldeter Kunde wurde erkannt, aber customer.id ist in Liquid nicht verfügbar.', metafield_save_error: 'Die Kundendaten konnten nicht gespeichert werden.', cart_update_error: 'Der Warenkorb konnte nicht aktualisiert werden: {status}', cart_not_confirmed: 'Shopify hat das Speichern der Rechnungsdaten nicht bestätigt.', vat_generic: 'USt-IdNr.',
      validation_required: 'Bitte füllen Sie dieses Feld aus.',
      validation_format: 'Bitte halten Sie das geforderte Format ein.',
      validation_email: 'Bitte geben Sie eine gültige E-Mail-Adresse ein.',
    },
    fr: {
      vat_warning: 'Transactions UE : saisissez un numéro de TVA intracommunautaire valide, faute de quoi une régularisation de TVA de 22 % sera appliquée ultérieurement.',
      only_cf_invalid: 'Avec cette option, le code fiscal doit contenir exactement 11 chiffres.',
      kicker: 'Facturation', title: 'Complétez vos informations fiscales', subtitle: 'Saisissez les informations requises avant de passer au paiement.', close: 'Fermer', business: 'Entreprise', business_hint: 'Société ou professionnel', private: 'Particulier', private_hint: 'Client particulier', country: 'Pays', country_it: 'Italie', country_de: 'Allemagne', country_fr: 'France', country_at: 'Autriche', only_cf: "Je possède uniquement le code fiscal de l'entreprise", company_cf: "Code fiscal de l'entreprise *", private_cf: 'Code fiscal *', vat: 'Numéro de TVA *', company_name: "Nom de l'entreprise *", sdi: 'Code SDI *', pec: 'E-mail certifié (PEC) *', cf_placeholder: 'Ex. : RSSMRA80A01H501U', company_placeholder: 'Nom légal complet de votre entreprise', sdi_placeholder: 'Ex. : A1B2C3D (7 caractères)', pec_placeholder: 'Ex. : entreprise@pec.it', cancel: 'Annuler', confirm: 'Confirmer et continuer', saving: 'Enregistrement...', retry: "Impossible d'enregistrer les informations. Veuillez réessayer.", edit: 'Modifier', delete: 'Supprimer les informations de facturation', business_invoice: "Facture d'entreprise", private_invoice: 'Facture particulier', invalid_cf: 'Le code fiscal doit contenir 11 chiffres ou 16 caractères alphanumériques.', invalid_vat: 'Le numéro de TVA italien doit contenir 11 chiffres.', sdi_or_pec: 'Saisissez au moins un code SDI ou une adresse PEC. Vous pouvez également saisir les deux.', offline: 'Aucune connexion : impossible de contacter le service des données client.', metafield_unavailable: 'Le service des données client est indisponible (HTTP {status}).', metafield_timeout: "Le service des données client n'a pas répondu dans les 5 secondes.", popup_missing: "La fenêtre des informations fiscales est introuvable sur cette page.", customer_id_missing: "Un client connecté a été détecté, mais customer.id n'est pas disponible dans Liquid.", metafield_save_error: "Impossible d'enregistrer les données client.", cart_update_error: 'Impossible de mettre à jour le panier : {status}', cart_not_confirmed: "Shopify n'a pas confirmé l'enregistrement des informations fiscales.", vat_generic: 'Numéro de TVA',
      validation_required: 'Veuillez remplir ce champ.',
      validation_format: 'Veuillez respecter le format demandé.',
      validation_email: 'Veuillez saisir une adresse e-mail valide.',
    }
  };

  const Logic = {
    activeTab: 'business',
    originalCheckoutButton: null,
    checkoutObserver: null,
    summaryContainer: null,
    previouslyFocusedElement: null,
    countryInitialized: false,
    allowCheckoutOnce: false,
    locale: 'it',

    init() {
      if (!document.getElementById('fiscalPopup')) return;
      this.locale = this.detectLocale();
      this.applyTranslations();
      this.setupValidationTranslations();
      this.summaryContainer = document.getElementById('datiFatturazione');
      this.loadCustomerMetafields();
      if (!this.summaryContainer) this.interceptCheckoutButton();
      this.bindEvents();
      this.setupInputFormatters();
      if (this.isSummaryContainerEmpty(this.summaryContainer) && this.getSavedData()) {
        this.renderSummary();
      }
      this.observeCheckoutButton();
    },

    detectLocale() {
      const rawLocale = window.Shopify?.locale || document.documentElement.lang || 'it';
      const locale = String(rawLocale).toLowerCase().split(/[-_]/)[0];
      return Object.prototype.hasOwnProperty.call(TRANSLATIONS, locale) ? locale : 'it';
    },

    t(key, replacements = {}) {
      let value = TRANSLATIONS[this.locale]?.[key] || TRANSLATIONS.it[key] || key;
      Object.entries(replacements).forEach(([name, replacement]) => {
        value = value.replace(`{${name}}`, String(replacement));
      });
      return value;
    },

    applyTranslations() {
      const popup = document.getElementById('fiscalPopup');
      if (!popup) return;
      popup.lang = this.locale;
      popup.querySelectorAll('[data-i18n]').forEach((element) => {
        element.textContent = this.t(element.dataset.i18n);
      });
      popup.querySelectorAll('[data-i18n-placeholder]').forEach((element) => {
        element.placeholder = this.t(element.dataset.i18nPlaceholder);
      });
      popup.querySelectorAll('[data-i18n-aria-label]').forEach((element) => {
        element.setAttribute('aria-label', this.t(element.dataset.i18nAriaLabel));
      });
    },

    interceptCheckoutButton() {
      const buttons = document.querySelectorAll(
        'button[name="checkout"]:not([data-fiscal-original]), input[name="checkout"]:not([data-fiscal-original])'
      );

      buttons.forEach((button) => {
        button.dataset.fiscalOriginal = 'true';
        button.style.display = 'none';
        this.originalCheckoutButton = button;

        const trigger = document.createElement('button');
        trigger.type = 'button';
        trigger.id = 'FiscalTriggerBtn';
        trigger.className = button.className;
        trigger.innerHTML = button.tagName === 'INPUT'
          ? (button.value || 'Checkout')
          : button.innerHTML;
        trigger.setAttribute('aria-haspopup', 'dialog');
        button.insertAdjacentElement('afterend', trigger);
      });
    },

    isSummaryContainerEmpty(container) {
      return Boolean(container) &&
        container.children.length === 0 &&
        container.textContent.trim() === '';
    },

    observeCheckoutButton() {
      this.checkoutObserver = new MutationObserver(() => {
        const summaryContainer = document.getElementById('datiFatturazione');
        if (!summaryContainer) {
          this.summaryContainer = null;
          return;
        }

        const containerChanged = summaryContainer !== this.summaryContainer;
        const containerIsEmpty = this.isSummaryContainerEmpty(summaryContainer);
        const savedData = this.getSavedData();

        this.summaryContainer = summaryContainer;

        if (!containerChanged && (!containerIsEmpty || !savedData)) return;

        this.checkoutObserver.disconnect();

        if (containerChanged) this.restoreCheckoutButton();
        if (containerIsEmpty && savedData) this.renderSummary();

        this.checkoutObserver.observe(document.body, {
          childList: true,
          subtree: true
        });
      });

      this.checkoutObserver.observe(document.body, {
        childList: true,
        subtree: true
      });
    },

    restoreCheckoutButton() {
      document.querySelectorAll('#FiscalTriggerBtn').forEach((trigger) => trigger.remove());
      document.querySelectorAll('[data-fiscal-original="true"]').forEach((button) => {
        button.style.display = '';
        delete button.dataset.fiscalOriginal;
      });
      this.originalCheckoutButton = null;
    },

    bindEvents() {
      document.addEventListener('click', (event) => {
        const checkoutButton = event.target.closest(
          'button[name="checkout"], input[name="checkout"]'
        );

        if (checkoutButton && this.allowCheckoutOnce) {
          this.allowCheckoutOnce = false;
          return;
        }

        if (this.summaryContainer && checkoutButton) {
          event.preventDefault();
          event.stopImmediatePropagation();

          const savedData = this.getSavedData();
          if (!savedData) {
            this.open();
            return;
          }

          this.saveCartAttributes(savedData)
            .then(() => this.saveCustomerMetafields(savedData))
            .then(() => {
              this.allowCheckoutOnce = true;
              checkoutButton.click();
            })
            .catch((error) => {
              const errorMessage = error?.message ||
                'Non è stato possibile salvare i dati di fatturazione.';
              window.alert(errorMessage);
            });
          return;
        }

        if (event.target.closest('#FiscalTriggerBtn')) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.open();
          return;
        }
      }, true);

      document.addEventListener('click', (event) => {
        if (event.target.closest('#closeFiscalX, #cancelFiscal')) this.close();

        if (event.target.closest('[data-fiscal-edit]')) {
          event.preventDefault();
          this.editSavedData();
          return;
        }

        if (event.target.closest('[data-fiscal-delete]')) {
          event.preventDefault();
          this.deleteSavedData();
          return;
        }

        const tab = event.target.closest('[data-tab-target]');
        if (tab) this.switchTab(tab.dataset.tabTarget);
        if (event.target.closest('#submitFiscal')) this.submit();
      });

      document.addEventListener('change', (event) => {
        if (event.target.id === 'onlyCF') Logic.toggleBusinessFields(event.target.checked);
        if (event.target.name === 'country') Logic.handleCountryChange(event.target.value);
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') this.close();
      });
    },

    initializeCountryFromMarket() {
      if (this.countryInitialized) return;

      const countrySelect = document.querySelector('#fiscalPopup select[name="country"]');
      const marketCountry = window.Shopify?.country?.toUpperCase();

      if (
        countrySelect &&
        marketCountry &&
        countrySelect.querySelector(`option[value="${marketCountry}"]`)
      ) {
        countrySelect.value = marketCountry;
      }

      this.countryInitialized = true;
    },

    open() {
      const popup = document.getElementById('fiscalPopup');
      if (!popup) return;

      if (!this.getSavedData()) this.initializeCountryFromMarket();

      if (!popup.contains(document.activeElement)) {
        this.previouslyFocusedElement = document.activeElement;
      }
      popup.inert = false;
      popup.classList.remove('closing');
      popup.classList.add('show');
      popup.setAttribute('aria-hidden', 'false');

      const country = popup.querySelector('select[name="country"]');
      if (country) Logic.handleCountryChange(country.value);
    },

    close() {
      const popup = document.getElementById('fiscalPopup');
      if (!popup || !popup.classList.contains('show')) return;

      popup.classList.add('closing');
      setTimeout(() => {
        if (popup.contains(document.activeElement)) {
          if (this.previouslyFocusedElement?.isConnected) {
            this.previouslyFocusedElement.focus({ preventScroll: true });
          } else {
            document.activeElement.blur();
          }
        }
        popup.classList.remove('show', 'closing');
        popup.inert = true;
        popup.setAttribute('aria-hidden', 'true');
      }, 300);
    },

    switchTab(tabName) {
      this.activeTab = tabName;
      document.querySelectorAll('.fiscal-tab').forEach((tab) => {
        const active = tab.dataset.tabTarget === tabName;
        tab.classList.toggle('active', active);
        tab.setAttribute('aria-selected', String(active));
      });
      document.querySelectorAll('.fiscal-tab-content').forEach((content) => {
        content.classList.toggle('active', content.id === `tab-${tabName}`);
      });
    },

    getSavedData() {
      try {
        return JSON.parse(sessionStorage.getItem('fiscal_data'));
      } catch (error) {
        console.error('Dati fiscali in sessione non validi:', error);
        return null;
      }
    },

    loadCustomerMetafields() {
      if (sessionStorage.getItem('fiscal_data')) return;

      const source = document.getElementById('fiscalCustomerMetafields');
      if (!source) return;

      try {
        const metafields = JSON.parse(source.textContent);
        const hasFiscalData = Object.values(metafields).some((value) => {
          return typeof value === 'string' && value.trim() !== '';
        });
        if (!hasFiscalData) return;

        const isBusiness = Boolean(
          metafields.ragione_sociale ||
          metafields.partita_iva ||
          (metafields.codice_sdi || metafields.pec)
        );

        const data = {
          tipo_cliente: isBusiness ? 'business' : 'private',
          country: window.Shopify?.country?.toUpperCase() || 'IT'
        };

        Object.entries(metafields).forEach(([key, value]) => {
          if (typeof value === 'string' && value.trim()) data[key] = value.trim();
        });

        sessionStorage.setItem('fiscal_data', JSON.stringify(data));
      } catch (error) {
        console.error('Lettura dei metafield cliente non riuscita:', error);
      }
    },

    renderSummary() {
      if (!this.summaryContainer) return;

      const data = this.getSavedData();
      this.summaryContainer.replaceChildren();
      if (!data) return;

      const isBusiness = data.tipo_cliente !== 'private';
      const summary = document.createElement('div');
      summary.className = 'fiscal-summary';

      const content = document.createElement('div');
      content.className = 'fiscal-summary-content';

      const title = document.createElement('strong');
      title.className = 'fiscal-summary-title';
      title.textContent = this.t(isBusiness ? 'business_invoice' : 'private_invoice');
      content.appendChild(title);

      const values = isBusiness
        ? [data.ragione_sociale, data.codice_fiscale, data.partita_iva, data.codice_sdi, data.pec]
        : [data.codice_fiscale];

      values.filter(Boolean).forEach((value) => {
        const line = document.createElement('span');
        line.textContent = value;
        content.appendChild(line);
      });

      const edit = document.createElement('button');
      edit.type = 'button';
      edit.className = 'fiscal-summary-edit';
      edit.dataset.fiscalEdit = '';
      edit.textContent = this.t('edit');
      content.appendChild(edit);

      const remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'fiscal-summary-delete';
      remove.dataset.fiscalDelete = '';
      remove.setAttribute('aria-label', this.t('delete'));
      remove.innerHTML = '<span aria-hidden="true">×</span>';

      summary.append(content, remove);
      this.summaryContainer.appendChild(summary);
    },

    editSavedData() {
      const data = this.getSavedData();
      if (!data) return;

      const tabName = data.tipo_cliente === 'private' ? 'private' : 'business';
      this.switchTab(tabName);

      const country = document.querySelector('select[name="country"]');
      if (country && data.country) country.value = data.country;
      if (country) this.handleCountryChange(country.value);

      const onlyFiscalCode = Boolean(data.solo_codice_fiscale);
      const checkbox = document.getElementById('onlyCF');
      if (checkbox) checkbox.checked = onlyFiscalCode;
      this.toggleBusinessFields(onlyFiscalCode);

      const form = document.getElementById(`${tabName}Form`);
      if (form) {
        Object.entries(data).forEach(([name, value]) => {
          const input = form.elements.namedItem(name);
          if (input && typeof value === 'string') input.value = value;
        });
      }

      this.open();
    },

    async deleteSavedData() {
      sessionStorage.removeItem('fiscal_data');
      this.renderSummary();

      document.getElementById('businessForm')?.reset();
      document.getElementById('privateForm')?.reset();
      this.switchTab('business');

      const checkbox = document.getElementById('onlyCF');
      if (checkbox) checkbox.checked = false;
      this.toggleBusinessFields(false);

      const country = document.querySelector('select[name="country"]');
      if (country) this.handleCountryChange(country.value);
      this.open();

      try {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            attributes: {
              invoice: '',
              'invoice-type': '',
              country: '',
              'fiscal-code': '',
              'company-name': '',
              vat: '',
              sdi: '',
              pec: ''
            }
          })
        });
      } catch (error) {
        console.error('Eliminazione dei dati fiscali dal carrello non riuscita:', error);
      }
    },

    toggleBusinessFields(onlyFiscalCode) {
      const vatInput = document.getElementById('business-piva');
      const vatGroup = vatInput?.closest('.fiscal-form-group');
      const fiscalCodeInput = document.getElementById('business-cf');

      if (vatInput) {
        vatInput.required = !onlyFiscalCode;
        vatInput.disabled = onlyFiscalCode;
        vatInput.setCustomValidity('');
      }
      if (vatGroup) {
        vatGroup.style.opacity = onlyFiscalCode ? '0.4' : '1';
        vatGroup.style.pointerEvents = onlyFiscalCode ? 'none' : 'auto';
      }
      if (fiscalCodeInput) {
        fiscalCodeInput.pattern = onlyFiscalCode
          ? '[0-9]{11}'
          : '([A-Z0-9]{16}|[0-9]{11})';
        fiscalCodeInput.maxLength = onlyFiscalCode ? 11 : 16;
        fiscalCodeInput.setCustomValidity('');
      }
    },

    handleCountryChange(countryCode) {
      const isItaly = countryCode === 'IT';
      const euVatWarning = document.getElementById('euVatWarning');
      if (euVatWarning) euVatWarning.hidden = isItaly;

      const vatInput = document.getElementById('business-piva');
      const examplePrefix = { it: 'Es:', en: 'E.g.', de: 'z. B.', fr: 'Ex. :' }[this.locale] || 'Es:';
      const vatRules = {
        IT: ['[0-9]{11}', 11, `${examplePrefix} 12345678901`],
        DE: ['[0-9]{9}', 9, `${examplePrefix} 123456789`],
        ES: ['[A-Z][0-9]{8}', 9, `${examplePrefix} X12345678`],
        AT: ['[A-Z][0-9]{8}', 9, `${examplePrefix} U12345678`],
        FR: ['[A-Z0-9]{13}', 13, `${examplePrefix} FR12345678901`],
        BE: ['0[0-9]{9}', 10, `${examplePrefix} 0123456789`],
        NL: ['[0-9]{9}B[0-9]{2}', 12, `${examplePrefix} 123456789B01`]
      };
      const [pattern, maxLength, placeholder] = vatRules[countryCode] || ['.*', 20, this.t('vat_generic')];

      if (vatInput) {
        vatInput.pattern = pattern;
        vatInput.maxLength = maxLength;
        vatInput.placeholder = placeholder;
        vatInput.setCustomValidity('');
      }

      ['business-cf', 'business-sdi', 'business-pec'].forEach((id) => {
        const input = document.getElementById(id);
        if (!input) return;
        input.closest('.fiscal-form-group').style.display = isItaly ? '' : 'none';
        input.required = isItaly && id === 'business-cf';
        input.disabled = !isItaly;
        input.setCustomValidity('');
        if (!isItaly) input.value = '';
      });

      const privateTab = document.querySelector('.fiscal-tab[data-tab-target="private"]');
      if (privateTab) {
        privateTab.style.display = isItaly ? '' : 'none';
        privateTab.setAttribute('aria-hidden', String(!isItaly));
      }
      if (!isItaly && this.activeTab === 'private') this.switchTab('business');

      const wrapper = document.querySelector('.fiscal-checkbox-wrapper');
      const checkbox = document.getElementById('onlyCF');
      if (wrapper) wrapper.style.display = isItaly ? '' : 'none';
      if (checkbox) {
        checkbox.disabled = !isItaly;
        if (!isItaly) checkbox.checked = false;
      }
      if (!isItaly) this.toggleBusinessFields(false);
    },

    validateItalianFiscal(data, onlyFiscalCode) {
      const fiscalCode = data.codice_fiscale
        ? data.codice_fiscale.toUpperCase().replace(/\s+/g, '')
        : '';
      const vatNumber = data.partita_iva ? data.partita_iva.replace(/\s+/g, '') : '';
      const elevenDigits = /^[0-9]{11}$/;
      const sixteenAlphanumeric = /^[A-Z0-9]{16}$/;

      if (onlyFiscalCode) {
        return elevenDigits.test(fiscalCode) ? true : this.t('only_cf_invalid');
      }

      if (!elevenDigits.test(fiscalCode) && !sixteenAlphanumeric.test(fiscalCode)) {
        return this.t('invalid_cf');
      }

      if (!elevenDigits.test(vatNumber)) return this.t('invalid_vat');
      return true;
    },

    setupValidationTranslations() {
      const popup = document.getElementById('fiscalPopup');
      if (!popup) return;

      popup.addEventListener('invalid', (event) => {
        const field = event.target;
        if (
          !(field instanceof HTMLInputElement) &&
          !(field instanceof HTMLSelectElement)
        ) return;

        // Mantiene gli errori specifici già impostati, come SDI/PEC.
        if (field.validity.customError) return;

        let key = 'validation_format';

        if (field.validity.valueMissing) {
          key = 'validation_required';
        } else if (
          field.type === 'email' &&
          field.validity.typeMismatch
        ) {
          key = 'validation_email';
        }

        field.setCustomValidity(this.t(key));
      }, true);

      // Rimuove l'errore precedente quando il cliente modifica il campo.
      const clearError = (event) => {
        const field = event.target;
        if (
          field instanceof HTMLInputElement ||
          field instanceof HTMLSelectElement
        ) {
          field.setCustomValidity('');
        }
      };

      popup.addEventListener('input', clearError);
      popup.addEventListener('change', clearError);
    },

    validateForm(form) {
      const data = Object.fromEntries(new FormData(form));
      const country = document.querySelector('select[name="country"]')?.value;
      const onlyFiscalCode = document.getElementById('onlyCF')?.checked || false;
      if (!form.checkValidity()) return false;

      if (country === 'IT' && this.activeTab === 'business') {
        if (!onlyFiscalCode && !data.codice_sdi?.trim() && !data.pec?.trim()) {
          const sdiInput = document.getElementById('business-sdi');
          sdiInput.setCustomValidity(this.t('sdi_or_pec'));
          sdiInput.reportValidity();
          return false;
        }

        const error = this.validateItalianFiscal(data, onlyFiscalCode);
        if (error !== true) {
          const targetId = error === this.t('invalid_vat') ? 'business-piva' : 'business-cf';
          const target = document.getElementById(targetId);
          target.setCustomValidity(error);
          target.reportValidity();
          return false;
        }
      }
      return true;
    },

    async checkMetafieldHost(endpoint) {
      if (!navigator.onLine) {
        throw new Error(this.t('offline'));
      }

      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 5000);

      try {
        await fetch(endpoint, {
          method: 'HEAD',
          cache: 'no-store',
          signal: controller.signal
        });
      } catch (error) {
        if (error.name === 'AbortError') {
          throw new Error(this.t('metafield_timeout'));
        }
        throw error;
      } finally {
        clearTimeout(timeoutId);
      }
    },

    async saveCustomerMetafields(data) {
      const popup = document.getElementById('fiscalPopup');
      if (!popup) {
        throw new Error(this.t('popup_missing'));
      }

      const customerId = popup.dataset.customerId?.trim() || '';
      const customerLoggedIn = Boolean(customerId) ||
        popup.dataset.customerLoggedIn === 'true' ||
        Boolean(document.getElementById('fiscalCustomerMetafields'));
      const endpoint = '/apps/configuratore-3d/metafield/save';

      if (!customerLoggedIn) return;

      if (!customerId) {
        throw new Error(this.t('customer_id_missing'));
      }

      if (!navigator.onLine) throw new Error(this.t('offline'));

      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 10000);

      try {
        const response = await fetch(endpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            ragione_sociale: data.ragione_sociale || '',
            partita_iva: data.partita_iva || '',
            codice_fiscale: data.codice_fiscale || '',
            codice_sdi: data.codice_sdi || '',
            pec: data.pec || ''
          }),
          signal: controller.signal
        });

        const responseText = await response.text();
        let result = null;
        try {
          result = responseText ? JSON.parse(responseText) : null;
        } catch (_) {
          result = null;
        }

        if (!response.ok) {
          const details = result?.error || responseText.replace(/\s+/g, ' ').trim().slice(0, 300);
          throw new Error(
            `Errore metafield HTTP ${response.status} su ${endpoint}${details ? `: ${details}` : ''}`
          );
        }

        if (!result?.success) {
          throw new Error(
            result?.error || `Risposta non valida da ${endpoint}: manca success: true.`
          );
        }
      } catch (error) {
        if (error.name === 'AbortError') {
          throw new Error(`Timeout durante il salvataggio su ${endpoint}.`);
        }
        throw error;
      } finally {
        clearTimeout(timeoutId);
      }
    },

    async saveCartAttributes(data) {
      const attributes = {
        invoice: 'yes',
        'invoice-type': data.tipo_cliente === 'private'
          ? 'Privato'
          : 'Azienda',
        country: data.country || 'IT',
        'fiscal-code': data.codice_fiscale || '',
        'company-name': data.ragione_sociale || '',
        vat: data.partita_iva || '',
        sdi: data.codice_sdi || '',
        pec: data.pec || ''
      };

      this.syncCartAttributeInputs(attributes);

      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ attributes })
      });

      if (!response.ok) {
        throw new Error(
          this.t('cart_update_error', { status: response.status })
        );
      }

      const updatedCart = await response.json();

      if (
        !updatedCart.attributes ||
        updatedCart.attributes['invoice-type'] !== attributes['invoice-type']
      ) {
        throw new Error(this.t('cart_not_confirmed'));
      }
    },

    async submit() {
      const form = document.getElementById(`${this.activeTab}Form`);
      form.querySelectorAll('input').forEach((input) => input.setCustomValidity(''));
      if (!this.validateForm(form)) {
        form.reportValidity();
        return;
      }

      const data = Object.fromEntries(new FormData(form));
      if (this.activeTab === 'business' && document.getElementById('onlyCF').checked) {
        delete data.partita_iva;
        data.solo_codice_fiscale = true;
      }

      data.tipo_cliente = this.activeTab;
      data.country = document.querySelector('select[name="country"]')?.value || '';
      sessionStorage.setItem('fiscal_data', JSON.stringify(data));
      // Shopify trasformerà questi cart attributes nei note_attributes dell'ordine.
      const attributes = {
        invoice: 'yes',
        'invoice-type': this.activeTab === 'business' ? 'Azienda' : 'Privato',
        country: data.country || 'IT',
        'fiscal-code': data.codice_fiscale || '',
        'company-name': data.ragione_sociale || '',
        vat: data.partita_iva || '',
        sdi: data.codice_sdi || '',
        pec: data.pec || ''
      };

      this.syncCartAttributeInputs(attributes);

      const submitButton = document.getElementById('submitFiscal');
      const submitStatus = document.getElementById('fiscalSubmitStatus');
      const originalButtonMarkup = submitButton.innerHTML;
      try {
        submitButton.textContent = this.t('saving');
        submitButton.disabled = true;
        if (submitStatus) submitStatus.textContent = '';
        const response = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes })
        });
        if (!response.ok) throw new Error(this.t('cart_update_error', { status: response.status }));

        const updatedCart = await response.json();
        if (!updatedCart.attributes || updatedCart.attributes['invoice-type'] !== attributes['invoice-type']) {
          throw new Error(this.t('cart_not_confirmed'));
        }

        await this.saveCustomerMetafields(data);

        this.close();
        if (this.summaryContainer) this.renderSummary();
        setTimeout(() => this.proceedToCheckout(), 350);
      } catch (error) {
        console.error(error);
        submitButton.innerHTML = originalButtonMarkup;
        submitButton.disabled = false;
        const errorMessage = error?.message || this.t('retry');
        if (submitStatus) submitStatus.textContent = errorMessage;
        window.alert(errorMessage);
      }
    },

    syncCartAttributeInputs(attributes) {
      document.querySelectorAll('[name^="attributes["]').forEach((input) => {
        const match = input.name.match(/^attributes\[([^\]]+)\]$/);
        if (!match) return;

        const attributeName = match[1];
        if (Object.prototype.hasOwnProperty.call(attributes, attributeName)) {
          input.value = attributes[attributeName];
        }
      });
    },

    proceedToCheckout() {
      const checkoutButton = this.originalCheckoutButton || document.querySelector(
        'button[name="checkout"], input[name="checkout"]'
      );

      if (checkoutButton) {
        this.allowCheckoutOnce = true;
        checkoutButton.click();
        return;
      }

      window.location.assign('/checkout');
    },

    setupInputFormatters() {
      document.addEventListener('input', (event) => {
        const input = event.target;
        if (!(input instanceof HTMLInputElement)) return;
        if (input.classList.contains('uppercase')) input.value = input.value.toUpperCase();
        if (input.name === 'codice_sdi') input.value = input.value.toUpperCase().replace(/[^A-Z0-9]/g, '');
        if (input.name === 'partita_iva') {
          const country = document.querySelector('select[name="country"]')?.value;
          input.value = ['IT', 'DE', 'BE'].includes(country)
            ? input.value.replace(/[^0-9]/g, '')
            : input.value.toUpperCase().replace(/[^A-Z0-9]/g, '');
        }
      });
    }
  };

  const start = () => {
    if (window.fiscalLogicLoaded) return;
    Logic.init();
    window.fiscalLogicLoaded = true;
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
